import { BasePageType } from "../base";
import CommunityPage from "./CommunityPage";

// Sample members data for testing
const sampleMembers = [
	{
		id: 1,
		name: "Sarah Chen",
		avatar: "https://i.pravatar.cc/150?img=5",
		role: "Book Club Leader",
		readingGoal: "52 books in 2024",
		currentlyReading: "The Midnight Library",
		joinDate: "2023-01-15",
		badges: ["Top Reader", "Discussion Leader"],
	},
	{
		id: 2,
		name: "Mike Johnson",
		avatar: "https://i.pravatar.cc/150?img=3",
		role: "Member",
		readingGoal: "24 books in 2024",
		currentlyReading: "Project Hail Mary",
		joinDate: "2023-03-20",
		badges: ["Active Participant"],
	},
	{
		id: 3,
		name: "Emma Wilson",
		avatar: "https://i.pravatar.cc/150?img=4",
		role: "Book Club Moderator",
		readingGoal: "36 books in 2024",
		currentlyReading: "Tomorrow, and Tomorrow, and Tomorrow",
		joinDate: "2023-02-10",
		badges: ["Event Organizer"],
	},
];

// Sample discussions data
const sampleDiscussions = [
	{
		id: 1,
		title: "Monthly Book Discussion: The Midnight Library",
		description: "Share your thoughts on Matt Haig's exploration of parallel lives and regret.",
		participants: 24,
		messages: 156,
		lastReadCount: 150,
		lastActive: "2024-03-10T14:30:00Z",
		tags: ["Current Read", "Fiction", "Book Discussion"],
		pinned: true,
	},
	{
		id: 2,
		title: "Science Fiction Book Recommendations",
		description: "Looking for your next sci-fi read? Share and discover recommendations here!",
		participants: 18,
		messages: 89,
		lastReadCount: 89,
		lastActive: "2024-03-09T18:15:00Z",
		tags: ["Science Fiction", "Recommendations"],
		pinned: false,
	},
	{
		id: 3,
		title: "Book Club Reading Challenge 2024",
		description: "Track your progress and share updates on your reading goals for the year.",
		participants: 45,
		messages: 234,
		lastReadCount: 220,
		lastActive: "2024-03-10T09:45:00Z",
		tags: ["Reading Challenge", "Goals"],
		pinned: true,
	},
];

// Sample messages data
const sampleMessages = [
	{
		id: 1,
		participants: [
			{
				id: 1,
				name: "Sarah Chen",
				avatar: "https://i.pravatar.cc/150?img=5",
			},
			{
				id: 2,
				name: "Current User",
				avatar: "https://i.pravatar.cc/150?img=8",
			},
		],
		messages: [
			{
				id: 1,
				senderId: 1,
				text: "I just finished reading The Midnight Library!",
				timestamp: "2024-03-10T15:20:00Z",
			},
			{
				id: 2,
				senderId: 2,
				text: "What did you think about it?",
				timestamp: "2024-03-10T15:21:00Z",
			},
		],
		lastRead: {
			1: 2,
			2: 1,
		},
	},
];

// Sample reading goals and updates
const sampleReadingUpdates = [
	{
		id: 1,
		userId: 1,
		userName: "Sarah Chen",
		userAvatar: "https://i.pravatar.cc/150?img=5",
		type: "goal_progress",
		content: "Finished book 12 of 52 for 2024!",
		timestamp: "2024-03-10T15:20:00Z",
		likes: 8,
		comments: 3,
	},
	{
		id: 2,
		userId: 2,
		userName: "Mike Johnson",
		userAvatar: "https://i.pravatar.cc/150?img=3",
		type: "reading_update",
		content: "Just started 'Project Hail Mary' - already hooked!",
		timestamp: "2024-03-10T12:45:00Z",
		likes: 5,
		comments: 2,
	},
	{
		id: 3,
		userId: 3,
		userName: "Emma Wilson",
		userAvatar: "https://i.pravatar.cc/150?img=4",
		type: "poll",
		content: "What should we read next month?",
		options: [
			{ text: "Cloud Cuckoo Land", votes: 12 },
			{ text: "Lessons in Chemistry", votes: 18 },
			{ text: "Tomorrow, and Tomorrow, and Tomorrow", votes: 15 },
		],
		timestamp: "2024-03-09T20:30:00Z",
		totalVotes: 45,
	},
];

export const CommunityPageType = {
	...BasePageType,
	component: CommunityPage,
	icon: "people-outline",
	title: "Community",
	getDefaultContent: () => ({
		members: sampleMembers,
		discussions: sampleDiscussions,
		messages: sampleMessages,
		readingUpdates: sampleReadingUpdates,
	}),
};

export default CommunityPageType;
